import { useMemo } from 'react';
import { omitBy, isNil } from 'lodash';

import { EMPTY_ARRAY, EMPTY_STRING } from '@e-socna/empty';

import type { MissionStateForm_MissionArchiveInfo } from '../fragments/mission-archive-info.fragment';

export const useInitialValuesFactory = (
  pInitialValues?: Readonly<Partial<MissionStateForm_MissionArchiveInfo>>,
) => {
  const initialValues: MissionStateForm_MissionArchiveInfo = useMemo(
    () => ({
      __typename: 'MissionArchiveInfo' as const,
      archiveBinders: EMPTY_ARRAY,
      endDateForAnalytics: new Date().toISOString(),
      iHavedCheckedThatHypothesisNotesHaveBeenUploaded: false,
      iHavedCheckedThatPlansHaveBeenUploaded: false,
      iHavedCheckedThatQuotationHasBeenUploaded: false,
      iHavedCheckedThatReportHasBeenUploaded: false,
      startDateForAnalytics: EMPTY_STRING,
      ...omitBy(pInitialValues, isNil),
    }),
    [pInitialValues],
  );

  return { initialValues };
};
